var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page)?_c('NotionRenderer',{attrs:{"block-map":_vm.page,"map-image-url":_vm.imageFormatter,"full-page":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }